module.exports = __webpack_public_path__ + "9485d2e46c3305b0db03a8c6b728d613.svg";